import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { HttpService } from 'src/app/services/http.service';
import { LanguageService } from 'src/app/services/language.service';
import { BikeComponent } from '../component';
import { SettingsService } from 'src/app/services/settings.service';
import { DataParserService } from 'src/app/services/data-parser.service';

@Component({
  selector: 'app-add-sub-component',
  standalone: false,
  templateUrl: './add-sub-component.component.html',
  styleUrl: './add-sub-component.component.scss'
})
export class AddSubComponentComponent implements OnInit {

  public loading: boolean = false;
  public subcomponentGroup: FormGroup = this.fb.group({
    oem: ['', [
      Validators.required
    ]],
    componentClass: [1, [
      Validators.required
    ]],
    component: ['', [
      Validators.required
    ]],
    componentVariant: ['', [
      Validators.required,
      Validators.maxLength(this.settingsService.getTitleMaxLength())
    ]]
  });

  get component() {
    return this.subcomponentGroup.get("component");
  }

  get oem() {
    return this.subcomponentGroup.get("oem");
  }

  get componentClass() {
    return this.subcomponentGroup.get("componentClass");
  }

  get componentVariant() {
    return this.subcomponentGroup.get("componentVariant");
  }

  private oeOptionsListAll: { id: number, name: string }[] = [];
  public oeOptionsList: { id: number, name: string }[] = [];
  public componentClassOptionsList: { id: number, name: string }[] = [];
  public componentList: BikeComponent[] = [];
  public batteryList: BikeComponent[] = [];
  public driveUnitList: BikeComponent[] = [];
  public remoteList: BikeComponent[] = [];
  public displayList: BikeComponent[] = [];
  public allComponentsList: BikeComponent[] = [];
  public brandOptionsList: { id: number, name: string, OEM_ID: number }[] = [];

  constructor(public languageService: LanguageService, private httpService: HttpService,
    private fb: FormBuilder, private router: Router, public settingsService: SettingsService,
    private dataParserService: DataParserService) {
  }

  ngOnInit(): void {
    forkJoin([
      this.httpService.getOEOptionsList(0, 0),
      this.httpService.getComponentClassOptionsList(),
      this.httpService.getComponentList(),
      this.httpService.getOEOptionsList(1, 1)
    ]).subscribe((resp) => {
      this.oeOptionsList = resp[0];
      this.componentClassOptionsList = resp[1];
      this.oeOptionsListAll = resp[3];
      if ((resp[2] as any).success) {
        this.allComponentsList = this.dataParserService.initComponents(resp[2], this.oeOptionsListAll, this.componentClassOptionsList);
      }
    });
  }
  public goBack() {
    this.router.navigate(['/components']);
  }

  public updateComponentList() {
    this.componentList = this.allComponentsList.filter((el) => { return el.ComponentClass == this.componentClass?.value });

    if (this.componentClass?.value == 4) {
      this.componentList = this.componentList.filter((el) => {
        return !el.ComponentName.includes("External");
      });
    }

    this.component?.setValue('');
  }

  public onSubmit(): void {
    this.subcomponentGroup.markAllAsTouched();

    if (this.subcomponentGroup.status == "VALID") {
      this.loading = true;

      const postData: { component_id: number, variant_name: string, oe: number } = {
        component_id: this.component?.value,
        variant_name: this.componentVariant?.value,
        oe: this.oem?.value
      }

      this.httpService.addComponentVariant(postData).subscribe({
        next: (resp: any) => {
          this.loading = false;
          if (resp?.success) {
            this.router.navigate(['/components']);
          }
        },
        error: (error) => { this.loading = false; }
      });
    }
  }
}
